module.exports = __webpack_public_path__ + "img/addSquare.91bfeb46.svg";